<template>
    <div class="input-group">
        <div class="input-group-prepend" v-if="prefix">
            <span class="input-group-text">{{prefix}}</span>
        </div>
        <input type="text" class="form-control" :placeholder="placeholder" :value="value" @input="input" @change="change" :max="max" :min="min" :disabled="disabled" :required="required" :step="step" />
        <div class="input-group-append" v-if="sufix">
            <span class="input-group-text">{{sufix}}</span>
        </div>
    </div>
</template>

<script>
import 'jquery.inputmask/dist/jquery.inputmask.bundle';

export default {
    props: {
        value: null,
        placeholder: null,
        required: null,
        disabled: null,
        max: null,
        min: null,
        step: null,
        prefix: {
            default: null
        },
        sufix: {
            default: null
        },
        format: {
            default: "int"
        }
    },
    mounted: function () {
        $(this.$el).find("input").inputmask('currency', {
            autoUnmask: true,
            radixPoint: (this.format == "int") ? "" : ",",
            groupSeparator: (this.format == "int") ? "" : ".",
            allowMinus: false,
            prefix: "",            
            digits: (this.format == "int") ? 0 : 2,
            digitsOptional: false,
            rightAlign: true,
            unmaskAsNumber: true
        });
    },
    watch: {
        value: function (value) {
            $(this.$el).find("input").val(value).trigger('input').trigger('change');
        }
    },
    methods: {
        change: function (event) {
            var v = event.target.value.replace(new RegExp((this.format == "int") ? "^0+|[^0-9]" : "[^0-9.,]", 'g'), '');
            $(this.$el).find("input").val(v).trigger('input').trigger('change');
            this.$emit('change', v);
        },
        input: function (event) {
            var v = event.target.value.replace(new RegExp((this.format == "int") ? "^0+|[^0-9]" : "[^0-9.,]", 'g'), '');
            $(this.$el).find("input").val(v).trigger('input').trigger('change');
            this.$emit('input', v);
        }
    }
};
</script>